(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["gallery"] && !Shopify.designMode) return;
  try {
    
// Script para galeri­a con scroll infinito
(function() {
  // Esperar a que el DOM está listo
  function initGallery() {
    console.log('Galeria com scroll infinito iniciada');
    
    const galleryGrid = document.getElementById('galleryGrid');
    const loadingSpinner = document.getElementById('loadingSpinner');
    const endMessage = document.getElementById('endMessage');
    const allImageWrappers = document.querySelectorAll('.gallery-image-wrapper');
    
    if (!galleryGrid || allImageWrappers.length === 0) {
      console.log('Não foram encontrados elementos da galeria');
      return;
    }
    
    let currentlyVisible = 3; // Inicialmente mostramos 6 imágenes
    const imagesPerLoad = 3; // Cargar 6 imágenes cada vez
    let isLoading = false;
    
    console.log('Total de imagenes:', allImageWrappers.length);
    console.log('Imagens inicialmente visíveis:', Math.min(currentlyVisible, allImageWrappers.length));
    
    // Función para mostrar más imágenes
    function loadMoreImages() {
      if (isLoading || currentlyVisible >= allImageWrappers.length) {
        return;
      }
      
      isLoading = true;
      if (loadingSpinner) {
        loadingSpinner.classList.add('show');
      }
      
      // Simular un pequeño delay para mostrar el spinner
      setTimeout(function() {
        const nextBatch = Math.min(currentlyVisible + imagesPerLoad, allImageWrappers.length);
        
        for (let i = currentlyVisible; i < nextBatch; i++) {
          if (allImageWrappers[i]) {
            allImageWrappers[i].classList.remove('hidden');
            console.log('Mostrando imagem:', i + 1);
          }
        }
        
        currentlyVisible = nextBatch;
        isLoading = false;
        
        if (loadingSpinner) {
          loadingSpinner.classList.remove('show');
        }
        
        // Si hemos mostrado todas las imágenes, mostrar mensaje final
        if (currentlyVisible >= allImageWrappers.length && endMessage) {
          setTimeout(function() {
            endMessage.classList.add('show');
          }, 300);
          console.log('Todas as imagens foram carregadas');
        }
        
        console.log('Imagens visíveis agora:', currentlyVisible);
      }, 800); // Delay de 800ms para mostrar el efecto de carga
    }
    
    // Función para detectar cuando el usuario llega al final
    function handleScroll() {
      if (isLoading || currentlyVisible >= allImageWrappers.length) {
        return;
      }
      
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
      const windowHeight = window.innerHeight;
      const documentHeight = Math.max(
        document.body.scrollHeight,
        document.body.offsetHeight,
        document.documentElement.clientHeight,
        document.documentElement.scrollHeight,
        document.documentElement.offsetHeight
      );
      
      // Cargar más cuando el usuario está a 1400px del final (aumentado para mejor detección)
      if (scrollTop + windowHeight >= documentHeight - 1400) {
        console.log('Utilizador quase no fim, a carregar mais imagens...');
        loadMoreImages();
      }
    }
    
    // Agregar event listener para scroll con throttling
    let scrollTimeout;
    function throttledScroll() {
      if (scrollTimeout) {
        clearTimeout(scrollTimeout);
      }
      scrollTimeout = setTimeout(handleScroll, 100);
    }
    
    // Agregar el event listener al window
    window.addEventListener('scroll', throttledScroll);
    
    // También detectar scroll en el documento por si acaso
    document.addEventListener('scroll', throttledScroll);
    
    // Verificar las imágenes
    const allImages = document.querySelectorAll('.gallery-image');
    allImages.forEach(function(img, index) {
      img.addEventListener('error', function() {
        console.error('Erro ao carregar a imagem', index + 1);
        // Ocultar el wrapper completo si hay error
        const wrapper = img.closest('.gallery-image-wrapper');
        if (wrapper) {
          wrapper.style.display = 'none';
        }
      });
    });
    
    // Verificar si hay suficiente contenido inicial
    setTimeout(function() {
      const windowHeight = window.innerHeight;
      const documentHeight = Math.max(
        document.body.scrollHeight,
        document.body.offsetHeight,
        document.documentElement.clientHeight,
        document.documentElement.scrollHeight,
        document.documentElement.offsetHeight
      );
      
      // Si el contenido inicial no llena la pantalla, cargar más automáticamente
      if (documentHeight <= windowHeight + 100 && currentlyVisible < allImageWrappers.length) {
        console.log('Conteúdo inicial insuficiente, carregando mais imagens...');
        loadMoreImages();
      }
    }, 1000);
    
    // Llamar handleScroll inicialmente por si ya estamos al final
    setTimeout(handleScroll, 500);
  }
  
  // Iniciar cuando el DOM están listo
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initGallery);
  } else {
    // DOM ya está listo
    initGallery();
  }
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
